// extracted by mini-css-extract-plugin
module.exports = {"socialProfileEnsure":"SocialProfileEnsure__socialProfileEnsure__8RgxU"};